<div class="card" style="min-height: calc(100vh - 9rem)">
  <app-header titulo="Campos" descricao="Área de mapeamento dos campos que o sistema irá receber"></app-header>

  <div class="mt-3">
    <p-toolbar styleClass="mb-4 gap-2">
      <ng-template pTemplate="left">
        <p-button
          severity="success"
          label="Novo Campo"
          icon="pi pi-plus"
          class="mr-2"
          (onClick)="abrirDialogo()" />
      </ng-template>
    </p-toolbar>
    <p-table [value]="campos" dataKey="id" editMode="row" [tableStyle]="{'min-width': '50rem'}">
      <ng-template pTemplate="caption">

      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th style="width:16%">Fonte</th>
          <th style="width:14%">Nome</th>
          <th style="width:18%">Variavel</th>
          <th style="width:14%">Tipo Recebimento</th>
          <th style="width:14%">Tipo Envio</th>
          <th style="width:10%">Data Lançamento?</th>
          <th style="width:14%"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-campo let-editing="editing" let-ri="rowIndex">
        <tr [pEditableRow]="campo">
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="campo.campo" />
              </ng-template>
              <ng-template pTemplate="output">
                {{campo.campo}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="campo.nome" />
              </ng-template>
              <ng-template pTemplate="output">
                {{campo.nome}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-cascadeSelect
                  [(ngModel)]="campo.variavel"
                  [options]="selecionarVariaveis"
                  optionLabel="codigo"
                  optionGroupLabel="codigo"
                  [optionGroupChildren]="['fontes', 'variaveis']"
                  [style]="{ minWidth: '14rem' }"
                  placeholder="Variavel"
                  appendTo="body"
                  [showClear]="true">

                  <ng-template pTemplate="option" let-option>
                    <span class="codigo">{{ option.codigo }}</span>
                    <span class="separador"> - </span>
                    <span class="descricao">{{ option.descricao }}</span>
                  </ng-template>

                </p-cascadeSelect>


              </ng-template>
              <ng-template pTemplate="output">
                {{campo.variavel?.codigo}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-dropdown
                  [options]="tipoDados"
                  appendTo="body"
                  [(ngModel)]="campo.tipo"
                  placeholder="Tipo" />

              </ng-template>
              <ng-template pTemplate="output">
                {{campo.tipo}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-dropdown
                  [options]="tipoDados"
                  appendTo="body"
                  [(ngModel)]="campo.tipoIntegracao"
                  placeholder="Tipo" />

              </ng-template>
              <ng-template pTemplate="output">
                {{campo.tipoIntegracao}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-toggleButton
                  [(ngModel)]="campo.dataLan"
                  onLabel="Sim"
                  offLabel="Não" [disabled]="true"/>
              </ng-template>
              <ng-template pTemplate="output">
                <p-toggleButton
                  [(ngModel)]="campo.dataLan"
                  onLabel="Sim"
                  offLabel="Não"
                (onChange)="trocaData(campo)" [disabled]="campo.dataLan"/>
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <div class="flex align-items-center justify-content-center gap-2">
              <p-button
                *ngIf="!editing"
                icon="pi pi-pencil"
                class="mr-2"
                [rounded]="true"
                [outlined]="true"
                severity="success"
                pInitEditableRow
                (onClick)="editarLinha(campo)" />
              <p-button
                *ngIf="!editing"
                icon="pi pi-trash"
                severity="danger"
                [rounded]="true"
                [outlined]="true"
                pInitEditableRow
                (onClick)="excluirCampo(campo)" />

              <button
                *ngIf="editing"
                pButton
                pRipple
                type="button"
                pSaveEditableRow
                icon="pi pi-check"
                (click)="salvarLinha(campo)"
                class="p-button-rounded p-button-text p-button-success mr-2">
              </button>
              <button
                *ngIf="editing"
                pButton pRipple
                type="button"
                pCancelEditableRow
                icon="pi pi-times"
                (click)="cancelar(campo, ri)"
                class="p-button-rounded p-button-text p-button-danger">
              </button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>


  <p-dialog
    [(visible)]="formDialog"
    [style]="{ width: '450px' }"
    header="Inclusão de campo"
    [modal]="true"
    styleClass="p-fluid">
    <ng-template pTemplate="content">

      <div class="field">
        <label for="name">Nome</label>
        <input
          type="text"
          pInputText
          id="name"
          [(ngModel)]="campoDialog.nome"
          required
          autofocus />
        <small class="p-error" *ngIf="formEnviado && !campoDialog.nome">
          Nome é obrigatório
        </small>
      </div>
      <div class="field">
        <label for="description">Fonte</label>
        <input
          type="text"
          pInputText
          id="campo"
          [(ngModel)]="campoDialog.campo"
          required
          autofocus />
        <small class="p-error" *ngIf="formEnviado && !campoDialog.campo">
          Campo é obrigatório
        </small>
      </div>

      <div class="field">
        <label for="variavel">Variável</label>
        <p-cascadeSelect
          [(ngModel)]="campoDialog.variavel"
          [options]="selecionarVariaveis"
          optionLabel="codigo"
          optionGroupLabel="codigo"
          [optionGroupChildren]="['fontes', 'variaveis']"
          [style]="{ minWidth: '14rem' }"
          placeholder="Variavel"
          appendTo="body"
          [showClear]="true">

          <ng-template pTemplate="option" let-option>
            <span class="codigo">{{ option.codigo }}</span>
            <span class="separador"> - </span>
            <span class="descricao">{{ option.descricao }}</span>
          </ng-template>

        </p-cascadeSelect>
      </div>

      <div class="field">
        <label class="mb-3">Tipo Recebimento</label>
        <p-dropdown
          [options]="tipoDados"
          appendTo="body"
          [(ngModel)]="campoDialog.tipo"
          placeholder="Tipo" />
      </div>

      <div class="field">
        <label class="mb-3">Tipo Envio</label>
        <p-dropdown
          [options]="tipoDados"
          appendTo="body"
          [(ngModel)]="campoDialog.tipoIntegracao"
          placeholder="Tipo envio" />
      </div>
    </ng-template>

    <ng-template pTemplate="footer">
      <p-button
        label="Cancelar"
        icon="pi pi-times"
        [text]="true"
        (onClick)="esconderDialogo()" />
      <p-button
        label="Salvar"
        icon="pi pi-check"
        [text]="true"
        (onClick)="salvarLinha(campoDialog)" />
    </ng-template>
  </p-dialog>

  <p-confirmDialog [style]="{ width: '450px' }" />

</div>


